import axios, { AxiosRequestConfig } from "axios";
import { handleAxiosError } from "../utils/handleAxiosError";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
} as AxiosRequestConfig);

instance.interceptors.response.use(
  response => response,
  error => {
    handleAxiosError(error);

    return Promise.reject(error);
  }
);

export default instance;
